import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./portal.css";
import SingleQuestion from "./singleQuestion";
// import {
//   fetchTraineeTestQuestions,
//   fetchTraineeTestAnswerSheet,
//   fetchPeanding,
// } from "../../../actions/traineeAction";
import {
  updateTraineeTestAnswerSheet,
  updateTraineeTestQuestions,
  fetchPending,
} from "../../../reducers/trainee";
import BgImage from "../../../assets/testPageBg.svg";
import apis from "../../../services/Apis";
import {
  fetchTraineeTestAnswerSheet,
  fetchTraineeTestQuestions,
} from "../../../features/trianeeAsync";
const Question = ({ mode, triggerSidebar, loading }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(location.search);
  const testid = queryParams.get("testid");
  const traineeid = queryParams.get("traineeid");

  const trainee = useSelector((state) => state.trainee);
  // console.log(trainee);

  const [shouldRenderQuestion, setShouldRenderQuestion] = useState(false);

  // useEffect(() => {
  //   if (!socket) return;

  //   socket.on("connect", () => {
  //     console.log("Socket connected:", socket.id);

  //     if (loading) {
  //       socket.emit("join_test", {
  //         testid,
  //         traineeid,
  //         socketid: socket.id,
  //       });

  //       socket.on("pending", (data) => {
  //         console.log("Data", data);
  //         dispatch(fetchPending({ data })); // ❌ don't pass socket
  //       });
  //     }
  //   });

  //   // Optional cleanup
  //   return () => {
  //     socket.off("connect");
  //     socket.off("pending");
  //   };
  // }, [loading, socket, dispatch, testid,traineeid]);

  useEffect(() => {
    // dispatch(fetchTraineeTestQuestions(testid));
    // dispatch(fetchTraineeTestAnswerSheet(testid, traineeid));

    const timeoutId = setTimeout(() => {
      setShouldRenderQuestion(true);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, [testid, traineeid]);

  return (
    <div className="question-holder-new">
      <div className="single-question-container-new">
        {shouldRenderQuestion &&
        trainee.answers.length > 0 &&
        trainee.questions.length > 0 ? (
          <SingleQuestion
            mode={mode}
            triggerSidebar={triggerSidebar}
            title={trainee.title}
            loading={loading}
          />
        ) : null}
      </div>

      <div className="ImagebgTest">
        <img src={BgImage} alt="" />
      </div>
    </div>
  );
};

export default Question;
